import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 20px;
    background: #f3f7f9;
    border: 1px solid rgba(147, 185, 177, 0.35);
    border-radius: 16px;
    padding: 24px;
    margin-bottom: 1em;
`;

export const IconWrapper = styled.div`
    flex: 0 0 auto;
    padding-top: 4px;

    svg
    {
        width: 40px;
        height: 40px;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    flex: 1;
`;

export const Title = styled.h3`
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    color: #333;
`;

export const Message = styled.p`
    margin: 0;
    font-size: 16px;
    line-height: 1.5;
    color: #555;
`;

export const ActionsSection = styled.div`
    margin-bottom: 2em;
`;

export const FamilyTitle = styled.h3`
    margin: 0 0 1em;
    font-size: 20px;
    font-weight: 600;
`;

export const FallbackActionsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 4px;

    > button
    {
        flex: 0 0 auto;
        width: auto !important;
    }
`;

export const FallbackWrapper = styled.div`
    padding: 0 10px;
    margin-top: 1em;
`;